import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Switch } from 'types';

interface Props {
  switches: Switch[] | undefined;
  selectedSwitchId: number | null;
  fullWidth?: boolean;
  handleSwitchChanged: (...args: any[]) => void;
  required?: boolean;
  error?: boolean;
}

const SwitchSelectLocal = ({
  switches,
  selectedSwitchId,
  handleSwitchChanged,
  fullWidth = false,
  required = false,
  error = false,
}: Props) => {
  return (
    <FormControl variant='outlined' fullWidth={fullWidth}>
      <InputLabel required={required} id='switch-select-label'>
        Switch
      </InputLabel>
      <Select
        labelId='switch-select-label'
        id='switch-select'
        name='switch'
        label='Switch'
        value={selectedSwitchId === null ? undefined : selectedSwitchId}
        onChange={handleSwitchChanged}
        placeholder='None'
        error={error}
      >
        <MenuItem value={-1}>
          <em>None</em>
        </MenuItem>
        {switches?.map((switchItem: any) => {
          return (
            <MenuItem key={switchItem.id} value={switchItem.id}>
              {switchItem.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SwitchSelectLocal;
